import type {LoaderFunctionArgs} from "react-router-dom"
import {json, defer} from "react-router-dom"
import axios from 'axios'

const VerificationLoader = ( {params}: LoaderFunctionArgs ) => {

  const getOrder = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API}/order/${params.uuid}`)
      return response.data
    }
    catch {
      throw json(
        {
          message: "Order Not Found",
        },
        { status: 400, statusText: 'Order Not Found' }
      );
    }
  }

  return defer({ orderDetails: getOrder() })

}

export default VerificationLoader
